


















import { Component, Mixins } from "vue-property-decorator";
import { ValidationObserver } from "vee-validate";
import BaseServiceMixin from "../mixins/base.service.mixin";
import { CompanyModel } from "../models/CompanyModel";
import XeroIntegration from "../components/XeroIntegration.vue";
import TwilioSetting from "../components/TwilioSetting.vue";
import CompanyDetail from "../components/CompanyDetail.vue";

@Component({
  components: {
    ValidationObserver,
    XeroIntegration,
    TwilioSetting,
    CompanyDetail,
  },
})
export default class Accounts extends Mixins(BaseServiceMixin) {
  private get company(): CompanyModel | null {
    return this.vuexStore.company;
  }
}
